import service from "@/store/services/layouts-service";

const state = {
  list: {},
  listActive: {},
  layout: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_LIST_ACTIVE: (state, listActive) => {
    state.listActive = listActive;
  },
  SET_RESOURCE: (state, layout) => {
    state.layout = layout;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  listActive({ commit, dispatch }, params) {
    return service.listActive(params).then(({ listActive }) => {
      commit("SET_LIST_ACTIVE", listActive);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then(layout => {
      commit("SET_RESOURCE", layout);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then(layout => {
      commit("SET_RESOURCE", layout);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then(layout => {
      commit("SET_RESOURCE", layout);
    });
  },

  activate({ commit, dispatch }, params) {
    return service.activate(params).then(layout => {
      commit("SET_RESOURCE", layout);
    });
  },

  deactivate({ commit, dispatch }, params) {
    return service.deactivate(params).then(layout => {
      commit("SET_RESOURCE", layout);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  }
};

const getters = {
  list: state => state.list,
  listActive: state => state.listActive,
  listTotal: state => state.meta.total,
  layout: state => state.layout,
  dropdown: state => {
    return state.list.map(layout => ({
      id: layout.id,
      nombre: layout.nombre
    }));
  }
};

const layouts = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default layouts;
